import httpService from "./httpService";
import utils from "./utils";

export default {
  findAllByDocCodeAndToDeptId(docCode, docId) {
    return httpService.get("/vbIncomingDoc/findAllByDocCodeAndToDeptId", {
      params: { docCode: docCode, docId: docId }
    });
  },

  findByForwardIncomingProcessId(forwardProcessId) {
    let params = { forwardProcessId: forwardProcessId };
    return httpService.get("/vbIncomingDoc/findByForwardIncomingProcessId", {
      params: params
    });
  },

  findAllForHcCommandsDocRelation(deptId, keyword, pageable) {
    let params = utils.merge(
      { deptId: deptId, keyword: keyword },
      utils.initPageableParams(pageable)
    );
    return httpService.get("/vbIncomingDoc/findAllForHcCommandsDocRelation", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingDocService.js